import { render, staticRenderFns } from "./date-column.vue?vue&type=template&id=6ba13854&scoped=true&"
import script from "./date-column.vue?vue&type=script&lang=js&"
export * from "./date-column.vue?vue&type=script&lang=js&"
import style0 from "./date-column.vue?vue&type=style&index=0&id=6ba13854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba13854",
  null
  
)

export default component.exports